import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function dashboardPathFor(role) {
  if (role === "admin") return "/admin";
  if (role === "staff") return "/staff";
  return "/dashboard";
}

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white/60" data-testid="auth-loading">
        Checking session…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (roles && roles.length && !roles.includes(user.role)) {
    // Redirect to the user's own role-appropriate dashboard (never loop back to current path)
    const target = dashboardPathFor(user.role);
    if (target === location.pathname) return null; // safety guard
    return <Navigate to={target} replace />;
  }
  return children;
}
